import type { ButtonProps, ButtonVariant } from "./ButtonProps.js";

export function generateButtonClasses({ variant, disabled }: ButtonProps): string {
	const btnVariants: Record<ButtonVariant, string> = {
		primary:
			"group bg-primary border-primary hover:text-primary focus:text-white active:text-white text-white bg-center focus:bg-primary hover:text-white group-hover:text-white active:bg-primary hover:border-secondary focus:border-primary group-hover:bg-secondary hover:bg-secondary",
		secondary:
			"group bg-white border-primary text-primary hover:border-primary hover:text-white group-hover:text-white focus:border-primary active:border-primary focus:text-white active:text-white group-hover:bg-primary hover:bg-primary focus:bg-primary active:bg-primary",
		tertiary:
			"group bg-white border-transparent text-primary hover:border-white hover:text-white group-hover:text-white focus:border-primary active:border-primary focus:text-white active:text-white group-hover:bg-secondary hover:bg-secondary focus:bg-secondary active:bg-secondary",
		gold: "group bg-gold border-gold hover:text-secondary focus:text-secondary active:text-secondary text-secondary bg-center focus:bg-gold-dark hover:text-secondary group-hover:text-secondary active:bg-gold-dark hover:border-gold-dark focus:border-gold-dark group-hover:bg-gold-dark hover:bg-gold-dark",
		dark: "group bg-secondary border-secondary hover:text-white focus:text-white active:text-white text-white bg-center focus:bg-secondary-300 hover:text-white group-hover:text-white active:bg-secondary-300 hover:border-secondary focus:border-secondary group-hover:bg-secondary-300 hover:bg-secondary-300",
		transparent: "group text-black flex gap-2 items-center",
		primaryTransparent: "group text-primary flex gap-4 items-center",
		custom: "",
	};
	const variantClass = btnVariants[variant ?? "primary"];

	const disabledClass = disabled && "opacity-50 pointer-events-none";

	if (variant !== "transparent" && variant !== "primaryTransparent") {
		return [
			"rounded-md flex gap-4 items-center no-underline border px-8 lg:px-9 py-3 font-bold transition-all duration-300 text-2xs lg:text-xs w-fit cursor-pointer",
			variantClass,
			disabledClass,
		]
			.filter(Boolean)
			.join(" ");
	}

	return [variantClass, disabledClass].filter(Boolean).join(" ");
}
